import React from "react";
import { useDispatch, useSelector } from "react-redux";
import GoogleChart from "../../../../components/googleChart/googleChart";
import DateFilters from "../views/DateFilters";
import { actionCreators } from "../redux/sagas/marketing";
import PropTypes from "prop-types";

const { toggleView } = actionCreators;
const ReferralBySource = ({ moduleName, state }) => {
  const dispatch = useDispatch();
  const {
    dataTable: { rows, cols },
    options,
    listeners,
    isTable,
    filters
  } = useSelector(state);

  let settings = { showRowNumber: false, frozenColumns: 1 };
  let fixedColumns = { ...settings, ...options };
  // switch between table and chart views
  const switchView = (view) => dispatch(toggleView({ moduleName, view, filters }));
  return (
    <div id="module-date-filters" data-testid={moduleName}>
      <DateFilters moduleName={moduleName} />
      <div className="chart-root">
        <GoogleChart
          chartName="referral_by_source_chart"
          isTableView={isTable}
          enableEventListeners
          height={400}
          chartType={isTable ? "Table" : "BarChart"}
          rows={rows}
          columns={cols}
          listeners={listeners}
          switchView={switchView}
          options={fixedColumns}
          showAdditionTooltip={false}
        />
      </div>
    </div>
  );
};

ReferralBySource.propTypes = { moduleName: PropTypes.string, state: PropTypes.func };

export default ReferralBySource;
